import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PublicCurrentPagesState {
    TabValue: number | null;
}

const initialState: PublicCurrentPagesState = {
    TabValue: null
};

const PublicCurrentPages = createSlice({
    name: 'PublicP',
    initialState,
    reducers: {
        setNewPage: (state, action: PayloadAction<number>) => {
            state.TabValue = action.payload;
        }
    }
})

export const {setNewPage} = PublicCurrentPages.actions

export default PublicCurrentPages.reducer
